import type { JobOfferContractType, JobOfferRemoteType } from '../../types/offres';
import { CONTRACT_TYPE_LABELS, REMOTE_TYPE_LABELS } from '../../types/offres';

const CONTRACT_COLORS: Record<JobOfferContractType, string> = {
  cdi: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  cdd: 'bg-blue-50 text-blue-700 border-blue-200',
  freelance: 'bg-amber-50 text-amber-700 border-amber-200',
  stage: 'bg-sky-50 text-sky-700 border-sky-200',
  alternance: 'bg-teal-50 text-teal-700 border-teal-200',
};

const REMOTE_COLORS: Record<JobOfferRemoteType, string> = {
  no: 'bg-slate-100 text-slate-600 border-slate-200',
  partial: 'bg-orange-50 text-orange-700 border-orange-200',
  full_remote: 'bg-green-50 text-green-700 border-green-200',
};

interface ContractBadgeProps {
  type: JobOfferContractType;
}

interface RemoteBadgeProps {
  type: JobOfferRemoteType;
}

export function ContractBadge({ type }: ContractBadgeProps) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${CONTRACT_COLORS[type]}`}>
      {CONTRACT_TYPE_LABELS[type]}
    </span>
  );
}

export function RemoteBadge({ type }: RemoteBadgeProps) {
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${REMOTE_COLORS[type]}`}>
      {REMOTE_TYPE_LABELS[type]}
    </span>
  );
}
